var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaieDiffDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.099,
    height: 82.099,
    viewBox: "0 0 82.099 82.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_382",
    x: 0,
    y: 0,
    width: 82.099,
    height: 82.099,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_383",
    x: 30.31,
    y: 30.304,
    width: 51.789,
    height: 51.786,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_384",
    x: 9.563,
    y: 28.82,
    width: 22.929,
    height: 22.929,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_385",
    x: 19.574,
    y: 28.827,
    width: 22.938,
    height: 22.927,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_386",
    x: 29.576,
    y: 28.825,
    width: 22.93,
    height: 22.931,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_387",
    x: 9.561,
    y: 38.844,
    width: 22.933,
    height: 22.944,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_388",
    x: 19.563,
    y: 38.853,
    width: 22.938,
    height: 22.927,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_389",
    x: 9.568,
    y: 48.866,
    width: 22.93,
    height: 22.93,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_390",
    x: 19.571,
    y: 48.854,
    width: 22.92,
    height: 22.952,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_391",
    x: 40.076,
    y: 40.847,
    width: 30.704,
    height: 30.7,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_273",
    "data-name": "Groupe 273",
    transform: "translate(14.328 -416.534)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_382-2",
    "data-name": "Trac\\xE9 382",
    d: "M58.77,455.708q-1.674-1.583-3.351-3.165a1.991,1.991,0,0,0-.5-.378,1.975,1.975,0,0,1-1.185-2.248c.106-1.241.025-2.5.025-3.8H-.317v.641q0,15.989,0,31.978a2.567,2.567,0,0,0,2.893,2.883q10.106,0,20.213-.013a1.273,1.273,0,0,1,1.115.585c1.217,1.5,2.492,2.955,3.726,4.4a1.589,1.589,0,0,1-.286.03c-8.365,0-16.729.016-25.095,0a7.466,7.466,0,0,1-7.569-7.591q-.022-21.934,0-43.868a7.493,7.493,0,0,1,7.61-7.62c.936-.008,1.873,0,2.9,0v-5.008H10.2V427.5H43.248v-4.968h5.007v5.013c1.123,0,2.163-.032,3.2.006a7.411,7.411,0,0,1,5.793,2.979,8.635,8.635,0,0,1,1.523,3.644ZM43.262,432.594H10.184v4.924H5.168v-4.968c-1.006,0-1.943-.012-2.88,0a2.5,2.5,0,0,0-2.6,2.607c-.016,1.522,0,3.046,0,4.569v1.289H53.754c0-2.065.031-4.087-.012-6.108a2.343,2.343,0,0,0-2.087-2.3c-1.109-.1-2.235-.021-3.421-.021v4.942H43.262Z",
    transform: "translate(14.33 -416.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_383-2",
    "data-name": "Trac\\xE9 383",
    d: "M80.866,493.071c-.171.938-.266,1.9-.523,2.81-1.9,6.744-6.261,11.028-13.11,12.477a16.874,16.874,0,1,1,13.3-19.813c.132.67.223,1.348.333,2.022Zm-5.009-1.276A11.891,11.891,0,1,0,63.974,503.71,11.927,11.927,0,0,0,75.856,491.795Z",
    transform: "translate(-7.77 -438.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_384-2",
    "data-name": "Trac\\xE9 384",
    d: "M11.206,472.364h4.929v4.929H11.206Z",
    transform: "translate(7.36 -437.54)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_385-2",
    "data-name": "Trac\\xE9 385",
    d: "M33.452,472.376V477.3H28.514v-4.927Z",
    transform: "translate(0.06 -437.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_386-2",
    "data-name": "Trac\\xE9 386",
    d: "M45.808,477.3v-4.931h4.93V477.3Z",
    transform: "translate(-7.23 -437.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_387-2",
    "data-name": "Trac\\xE9 387",
    d: "M16.136,494.639H11.2V489.7h4.933Z",
    transform: "translate(7.36 -444.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_388-2",
    "data-name": "Trac\\xE9 388",
    d: "M28.495,494.637V489.71h4.938v4.927Z",
    transform: "translate(0.07 -444.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_389-2",
    "data-name": "Trac\\xE9 389",
    d: "M16.145,507.022v4.93h-4.93v-4.93Z",
    transform: "translate(7.35 -452.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_390-2",
    "data-name": "Trac\\xE9 390",
    d: "M33.43,511.954H28.51V507h4.92Z",
    transform: "translate(0.06 -452.15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.33, 416.53)",
    filter: "url(#Trac\\xE9_391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_391-2",
    "data-name": "Trac\\xE9 391",
    d: "M66.362,500.3v-1.573c-.045,0-.109-.008-.174-.008-.471,0-.943.005-1.414,0a.8.8,0,0,1-.781-.576.765.765,0,0,1,.329-.875,1.04,1.04,0,0,1,.472-.132c.6-.016,1.2-.006,1.805-.006h.206a6.441,6.441,0,0,1,1.379-2.088,6.357,6.357,0,0,1,8.067-.8.8.8,0,0,1,.408.779.786.786,0,0,1-1.241.573,5.126,5.126,0,0,0-1.6-.718,4.771,4.771,0,0,0-5.157,2.1c-.022.036-.043.073-.084.144h.215q1.944,0,3.889,0a.794.794,0,0,1,.606,1.321.844.844,0,0,1-.685.27c-1.458,0-2.916,0-4.373-.006-.191,0-.268.05-.264.244.009.383.006.767,0,1.15,0,.149.059.2.212.2q2.2-.009,4.391,0a1.28,1.28,0,0,1,.385.05.78.78,0,0,1,.521.881.79.79,0,0,1-.787.657c-.949,0-1.9,0-2.847,0H68.568c.125.186.224.351.341.5a4.758,4.758,0,0,0,6.439,1.071.875.875,0,0,1,.625-.183.8.8,0,0,1,.669.592.785.785,0,0,1-.337.86,6.152,6.152,0,0,1-2.287.987,6.342,6.342,0,0,1-7.15-3.7.2.2,0,0,0-.222-.136c-.633,0-1.265.007-1.9,0a.79.79,0,0,1-.254-1.536,1.229,1.229,0,0,1,.365-.052C65.359,500.3,65.861,500.3,66.362,500.3Z",
    transform: "translate(-14.89 -446.31)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaieDiffDash);
export default __webpack_public_path__ + "static/media/paie-diff-dash.3f5bdd1ab693671c506bc0bc1a980995.svg";
export { ForwardRef as ReactComponent };